import authReducer from './reducers';

export const { authorize, deAuthorize } = authReducer.actions;
